// @ts-nocheck
import { electricPurple000, robotoRegular, scarpaGray300, scarpaGray800, spanishViridian500 } from '@habitech/shared';
import styled from 'styled-components';

export const RootButtonSelection = styled.div``;

export const ButtonGroup = styled.div`
    width: 100%;
    height: 48px;
    display: flex;
    border-radius: 8px;
    .button-selection {
        cursor: pointer;
        width: 100%;
        display: flex;
        text-align: center;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 12px;
        font-family: ${robotoRegular};
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        background: ${electricPurple000};
        border: solid #78747b;
        border-top-width: 1px;
        border-bottom-width: 1px;
        border-right-width: 0.5px;
        border-left-width: 0.5px;
        color: ${scarpaGray800};
        &:last-of-type {
            border-radius: 0 8px 8px 0;
            border-right-width: 0.5px;
            border-left-width: 0.5px;
        }
        &:first-of-type {
            border-radius: 6px 0px 0px 6px;
            border-right-width: 0.5px;
            border-left-width: 0.5px;
        }

        background: ${electricPurple000};

        border-radius: 0px;
        &.in-active,
        &:hover {
            background: ${spanishViridian500};
            border: solid ${spanishViridian500};
            display: flex;
            align-items: center;
            &:last-of-type {
                border-radius: 0 8px 8px 0;
            }
            &:first-of-type {
                border-radius: 6px 0px 0px 6px;
            }

            color: ${electricPurple000};
        }

        &.disabled {
            border: solid ${scarpaGray300};
            color: ${scarpaGray300};
        }
    }
`;
export const Label = styled.div`
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 16px;
    color: ${scarpaGray800};
    @media ${({ theme }) => theme.screenSizes.tablet} {
        font-size: 16px;
    }
    @media ${({ theme }) => theme.screenSizes.laptop} {
        font-size: 16px;
    }
`;
